var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-background",class:'background-' + _vm.background,style:({
		height: _vm.height + 'px',
		top: _vm.top + 'px',
	}),attrs:{"id":'background-' + _vm.cid}})
}
var staticRenderFns = []

export { render, staticRenderFns }